<template>
  <div :class="outgoingMessage ? 'outgoing-message-footer' : 'incoming-message-footer'">
    <div v-if="showAvatar" class="avatar-placeholder"></div>
    <p :class="outgoingMessage ? 'message-timestamp-outgoing' : 'message-timestamp-incoming'" class="message-margin">
      {{ getFormattedTimeStamp }}
    </p>
  </div>
</template>

<script>
import format from 'date-fns/format'

export default {
  props: {
    showAvatar: {
      type: Boolean,
      default: false,
    },
    outgoingMessage: {
      type: Boolean,
      default: false,
    },
    timestamp: {
      type: Number,
    },
  },
  computed: {
    getFormattedTimeStamp() {
      if (this.getFormattedDateFromDate(this.timestamp) === this.getTodaysDate()) {
        return this.getFormattedTimeFromDate(this.timestamp)
      } else {
        return this.getFormattedDateFromDate(this.timestamp)
      }
    },
  },
  methods: {
    getFormattedDateFromDate(date) {
      return format(new Date(date), 'M/D/YY')
    },
    getFormattedTimeFromDate(date) {
      return format(new Date(date), 'h:mm A')
    },
    getTodaysDate() {
      return format(new Date(), 'M/D/YY')
    },
  },
}
</script>

<style scoped>
.outgoing-message-footer {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.incoming-message-footer {
  display: flex;
}

.message-timestamp-incoming {
  padding: 5px 0px;
  color: #757575;
  font-size: 12px;
}

.message-timestamp-outgoing {
  font-size: 12px;
  padding: 5px 0px;
  color: #757575;
  margin-left: 0;
  margin-right: 0;
}

.avatar-placeholder {
  min-width: 30px;
  min-height: 30px;
  margin-right: 15px;
}
</style>
